<ui-form-autocomplete
  [formControl]="control"
  [data]="customerAutocomplete()"
></ui-form-autocomplete>
